/**
 * Convert any Axios / FastAPI error into a clean human-readable string.
 * Handles: plain string detail, Pydantic 422 array of {loc, msg, type}, dict detail with `message`, etc.
 */
export function formatApiError(error, fallback = 'Something went wrong') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;

  // Pydantic 422 — array of validation errors
  if (Array.isArray(detail)) {
    const parts = detail.map((d) => {
      const field = Array.isArray(d?.loc) ? d.loc.filter((x) => x !== 'body').join('.') : '';
      const msg = d?.msg || 'Invalid value';
      return field ? `${field}: ${msg}` : msg;
    });
    return parts.join(', ') || fallback;
  }

  // Object detail with message/code (e.g., our 402 payment errors)
  if (detail && typeof detail === 'object') {
    if (detail.message) return detail.reason ? `${detail.message} ${detail.reason}` : detail.message;
    return JSON.stringify(detail);
  }

  // Fallback to error.message
  if (error?.message && error.message !== 'Network Error') return error.message;
  return fallback;
}
